import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { BottomNavigation, TopNavigation } from "../navigation";
import MotifButton from "@ey/motif-react-wrapper/Button";
import {
  RemoteComponent,
  getFederatedObject,
  getKronosUrl,
  componentModule,
  FederatedObject,
} from "../moduleFederation";

const DryDock: React.FC = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const location = useLocation();

  const herculesUri = location.state;

  const [selectedLink, setSelectedLink] = useState<FederatedObject | null>(null);

  const engagementId = searchParams.get("engagementId");

  const onBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const onClose = useCallback(() => {
    setSelectedLink(null);
  }, []);

  const onCreated = useCallback(() => {
    setSelectedLink(null);
  }, []);

  const onCreateDeficiency = useCallback(async () => {
    const kronosUrl = await getKronosUrl(herculesUri);

    if (!kronosUrl) {
      return;
    }

    const federatedObject = getFederatedObject(kronosUrl!, componentModule.CreateDeficiency);

    setSelectedLink(federatedObject);
  }, [herculesUri]);

  const onCreateMisstatement = useCallback(async () => {
    const kronosUrl = await getKronosUrl(herculesUri);

    if (!kronosUrl) {
      return;
    }

    const federatedObject = getFederatedObject(kronosUrl!, componentModule.CreateMisstatement);

    setSelectedLink(federatedObject);
  }, [herculesUri]);

  return (
    <StyledDryDock>
      <TopNavigation />
      <section className="dry-dock-container">
        <MotifButton size="small" variant="primary" onClick={onCreateDeficiency}>
          Create Deficiency
        </MotifButton>
        <MotifButton size="small" variant="primary" onClick={onCreateMisstatement}>
          Create Misstatement
        </MotifButton>
        {selectedLink && (
          <RemoteComponent
            federatedObject={selectedLink}
            engagementId={engagementId}
            onClose={onClose}
            onCreated={onCreated}
          />
        )}
      </section>
      <BottomNavigation onBack={onBack} hideNext={true} />
    </StyledDryDock>
  );
};

export default DryDock;

const StyledDryDock = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  flex-direction: column;

  .dry-dock-container {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 1;
    flex-direction: column;
    padding: var(--spacing-medium);

    .motif-button {
      margin-bottom: var(--spacing-small);
    }
  }
`;
